import React, { memo, useEffect, useRef, useState } from 'react';
import { View, Platform, SafeAreaView, Text } from 'react-native';
import WebView from 'react-native-webview';
import { useDispatch, useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import Loader from '../../components/Loader/loader';
import { getCleanUrl } from '../../utils/Helper';
import { useNavigation } from '@react-navigation/native';
import { ImageComp } from '../../components/Image/Image';
import { handleMessageEventListener } from '../../js/eventListener';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const IFrameViewer = () => {
  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const navigate = useNavigation();
  const insets = useSafeAreaInsets();


  const { currentWidget } = useSelector(state => state.deviceConfigSlice);

  const [loading, setLoading] = useState(true);
  const cleanedUrl = getCleanUrl(currentWidget?.targetUrl);
  const [url, setUrl] = useState(cleanedUrl);

  const webViewRef = useRef();
  const iframeRef = useRef();

  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleMessage = (event) => {
        dispatch(handleMessageEventListener(event, iframeRef, navigate));
      };

      window.addEventListener('message', handleMessage);

      setTimeout(() => setLoading(false), 3000);

      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderHeader = () => {
      return (
          <View style={getStyles(['widgetmainContainerHeaderContainer', 'iFrameHeaderContainer',`iFrameHeaderContainer_${currentWidget?.widgetMetaHtmlId}`])} id={`iFrameHeaderContainer iFrameHeaderContainer_${currentWidget?.widgetMetaHtmlId}`}>
              {
                  currentWidget?.widgetHeaderImageUrl && 
                      <ImageComp
                          source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                          style={getStyles(['widgetmainContainerHeaderImg', 'iFrameHeaderImg', `iFrameHeaderImg_${currentWidget?.widgetMetaHtmlId}`])} id={"iFrameHeaderImg"}
                      />
              }
              <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'iFrameHeaderTitleContainer', `iFrameHeaderTitleContainer_${currentWidget?.widgetMetaHtmlId}`])} id={`iFrameHeaderTitleContainer iFrameHeaderTitleContainer_${currentWidget?.widgetMetaHtmlId}`}>
                <Text style={getStyles(['widgetmainContainerHeaderTitle', 'iFrameHeaderTitle', `iFrameHeaderTitle_${currentWidget?.widgetMetaHtmlId}`])} id={`iFrameHeaderTitle iFrameHeaderTitle_${currentWidget?.widgetMetaHtmlId}` }>
                  {currentWidget?.widgetTitle}
                </Text>
              </View>
          </View>
      )
  }

  return (
    <View
      style={[
        getStyles(['widgetRootContainer', 'iFrameRootContainer'])
      ]}
      id="widgetRootContainer iFrameRootContainer">
      <HeaderWithBack />
      
      <View
        style={getStyles(['widgetmainContainer', 'iFrameMainContainer'])}
        id="widgetmainContainer iFrameMainContainer">

        {renderHeader()}

        <View style={getStyles(['widgetmainContainerChildContainer', 'iFrameMainContainerChildContainer',`iFrameMainContainerChildContainer_${currentWidget?.widgetMetaHtmlId}`, Platform.OS === 'android' && {marginBottom: insets.bottom}])} id={`iFrameMainContainerChildContainer iFrameMainContainerChildContainer_${currentWidget?.widgetMetaHtmlId}`}>
          {Platform.OS === 'web' ? (
            <iframe
              ref={iframeRef}
              src={url}
              style={getStyles([
                'iframe',
                `iFrame_${currentWidget?.widgetMetaHtmlId}`,
                {marginTop: 0}
              ])}
              title={currentWidget?.displayName}
              onLoad={() => setLoading(false)}
              id={`iFrame iFrame_${currentWidget?.widgetMetaHtmlId}`}
            />
          ) : (
            <WebView
              ref={webViewRef}
              originWhitelist={['*']}
              style={getStyles([
                'widgetmainContainerChildContainer',
                'webViewMainContainerChildContainer',
                `webView_${currentWidget?.widgetMetaHtmlId}`
              ])}
              source={{ uri: url }}
              javaScriptEnabled={true}
              allowsInlineMediaPlayback={true}
              allowsFullscreenVideo={false}
              

              cacheEnabled={true}
              onLoad={() => setLoading(false)}
              onLoadStart={() => setTimeout(() => setLoading(false), 3000)}
              onMessage={(event)=> dispatch(handleMessageEventListener(event, webViewRef, navigate))}
            />
          )}
        </View>
      </View>

      {loading && (
          <>
            <View style={{ height: "100%", justifyContent: "center", alignItems: "center" }}>
              <Loader style={getStyles(['crossOverContaniner_loader'])} />
            </View>
          </>
        )}
    </View>
  );
};


export default memo(IFrameViewer);